export async function handleResponse<T>(res: Response): Promise<T> {
  const body = await res.json().catch(() => ({}))
  
  if (!res.ok) throw new Error(body.message ?? 'Error inesperado')

  return body
}

export async function get<T>(url: string) {
  return await fetch(url, { 
    method: 'GET' , 
    credentials: "include"
  }).then(res => handleResponse<T>(res))  
}

export async function del(url: string) {
  return await await fetch(url, { 
    method: 'DELETE', 
    credentials: "include" 
  }).then(handleResponse)  
}

export async function post(url: string, data: unknown) {
  return await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
    credentials: "include" 
  }).then(handleResponse)
}

export async function patch (url: string, data: unknown) {
  return await fetch(url, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
    credentials: "include" 
  }).then(handleResponse)
}